import React from 'react';
import PropTypes from 'prop-types';
import { getBaseUrl, handleBodyScrollHidden, sentenceCase } from '../../../utils/helpers';
import { languageController } from '../../../controllers/language/languageController';

function AccessoryCard({
  name,
  image,
  price,
  popular,
  description,
  setIsModalOpen,
  setExpandViewProps,
}) {
  const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
  const imageSrc = `${imagePath}/accessories/${image}`;

  const displayExpandedView = () => {
    handleBodyScrollHidden(true);
    setIsModalOpen(true);
    setExpandViewProps({
      title: name,
      description: description,
      imageSrc: imageSrc,
      imageAlt: name,
    });
  }

  return (
    <div className={`accessory-card`}>
      <div className="accessory-card__content">

        {popular && <p className="accessory-card__popular label upper">{languageController.getCopy('global', 'popular')}</p>}

        <img className="accessory-card__img" alt={name} src={imageSrc} onClick={displayExpandedView} />

        <div className="accessory-card__info">
          <p className="accessory-card__title m-0">{sentenceCase(name)}</p>
        </div>

        <div className="accessory-card__CTAs">
          <p className="accessory-card__price">{`$${Math.round(price)} ${languageController.getCopy('vehicleAccessories', 'priceSuffix')}`}</p>
          <button className="mz-link accessory-card__learn-more-button" onClick={displayExpandedView}>{languageController.getCopy('global', 'learnMore')}</button>
        </div>

      </div>
    </div>
  )
}

AccessoryCard.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  popular: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  setExpandViewProps: PropTypes.func.isRequired,
}

export default AccessoryCard;